import React from 'react'
import "./style.scss"
const Spinner = () => {
  return (
    <div className="spinner-container">
    <div className="post">
    <div className="avatar"></div>
    <div className="line"></div>
    <div className="line"></div>
    </div>
    <div className="post">
    <div className="avatar"></div>
    <div className="line"></div>
    <div className="line"></div>
    </div>
    <div className="post">
    <div className="avatar"></div>
    <div className="line"></div>
    <div className="line"></div>
    </div>
    </div>
  )
}

export default Spinner
